export const initialFormData = {
    email: "",
    store_name: "",
    address_line1: "",
    pincode: "",
    city: "",
    state: "",
    country: "",
  };
  